/**
 * PAGE: FACTURATION & TOKENS
 * Gestion des achats de tokens et historique des paiements
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/auth/AuthProvider';
import PricingPlans from '../components/billing/PricingPlans';
import TokenDashboard from '../components/billing/TokenDashboard';
import SubscriptionManager from '../components/billing/SubscriptionManager';
import PublicLayout from '../components/layout/PublicLayout';
import { getLoginUrl } from '../utils/domain';

export default function Billing() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState<'plans' | 'dashboard' | 'subscription'>('plans');

  // Redirection vers login si non connecté
  useEffect(() => {
    if (!loading && !user) {
      const loginUrl = getLoginUrl();
      if (loginUrl.startsWith('http')) {
        window.location.href = loginUrl;
      } else {
        navigate(loginUrl);
      }
    }
  }, [loading, user, navigate]);

  if (!user || loading) {
    return (
      <div className="min-h-screen bg-theme-base flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-accent-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-theme-secondary">Vérification de l'authentification...</p>
        </div>
      </div>
    );
  }

  return (
    <PublicLayout>
      <section className="pub-wrap pt-10">
        <p className="home-kicker mb-2">Compte</p>
        <h1 className="font-display text-4xl mb-6">Facturation</h1>
        <div className="flex gap-0 overflow-x-auto border-b border-theme mb-10">
          <button
            onClick={() => setActiveView('plans')}
            className={`studio-tab ${activeView === 'plans' ? 'is-active' : ''}`}
          >
            Plans
          </button>
          <button
            onClick={() => setActiveView('subscription')}
            className={`studio-tab ${activeView === 'subscription' ? 'is-active' : ''}`}
          >
            Abonnement
          </button>
          <button
            onClick={() => setActiveView('dashboard')}
            className={`studio-tab ${activeView === 'dashboard' ? 'is-active' : ''}`}
          >
            Usage
          </button>
        </div>

        {activeView === 'plans' && (
          <div>
            <h2 className="font-display text-3xl font-medium mb-3">Rechargez vos tokens</h2>
            <p className="text-theme-secondary mb-10 font-light">
              Choisissez le pack. Tokens valables à vie.
            </p>
            <PricingPlans />
          </div>
        )}

        {activeView === 'subscription' && (
          <div>
            <h2 className="font-display text-3xl font-medium mb-3">Mon abonnement</h2>
            <p className="text-theme-secondary mb-10 font-light">
              Gérez votre abonnement et vos paiements.
            </p>
            <SubscriptionManager />
          </div>
        )}

        {activeView === 'dashboard' && (
          <TokenDashboard />
        )}
      </section>
    </PublicLayout>
  );
}

